// Generated by CoffeeScript 2.7.0
var VertexConfig, business_time_comp, operation_btn_checkbox, operation_btn_mixins, operation_btn_switch, user_boundary_select_comp;

import DropdownSelect from 'trunks/vue/admin/components/libs/dropdown_select.js';

import BusinessTimeConfig from 'trunks/vue/admin/components/yet_another_workflow/_business_time.js';

import UserBoundaryConfig from 'trunks/vue/admin/components/yet_another_workflow/_user_boundary.js';

import PopoverFieldSelect from 'trunks/vue/admin/components/popover_field_select.js';

import TimeSpan from 'trunks/vue/admin/components/time_span.js';

import {
  TabItem,
  Tabs
} from 'trunks/vue/admin/components/libs/tabs.js';

user_boundary_select_comp = UserBoundaryConfig;

business_time_comp = BusinessTimeConfig;

operation_btn_mixins = {
  props: {
    button: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    customClass: {
      type: String,
      default: ''
    }
  },
  computed: {
    typeText: function() {
      return Skylark.Helpers.getZH_CN(`assignment.operates.${this.type}`);
    },
    isDisabled: function() {
      return this.button.hasOwnProperty('disabled');
    }
  }
};

operation_btn_switch = {
  mixins: [operation_btn_mixins],
  template: `<div class='list-item' :class='customClass'>
  <div class="tip">{{ typeText }}</div>
  <div class="content">
    <input type="text" v-model.trim='button.name'
           placeholder='自定义文案'
           v-if='!isDisabled && button.enabled' />
    <label class="switch small">
      <input type="checkbox" hidden='true' v-model='button.enabled' />
      <span></span>
    </label>
  </div>
</div>`
};

operation_btn_checkbox = {
  mixins: [operation_btn_mixins],
  computed: {
    renameable: function() {
      return this.button.hasOwnProperty('name');
    }
  },
  template: `<div class="list-item" :class='customClass'>
  <div class="tip">
    <label class="option-item" :class="{ 'readonly': isDisabled }">
      <input type="checkbox"
             hidden='true'
             v-if='isDisabled'
             checked='true'
             disabled='true' />
      <input type="checkbox"
             v-else
             hidden='true'
             v-model='button.enabled' />
      <i class="slp-square-o"></i>
      <span class="option-label">{{ typeText }}</span>
    </label>
  </div>
  <div class="content" v-if='renameable'>
    <input type="text" placeholder='自定义文案'
           maxLength='4'
           v-model.trim='button.name' />
  </div>
</div>`
};

export default VertexConfig = Vue.extend({
  props: {
    element: {
      type: Skylark.App.Model.YetAnotherWorkflow.Vertex,
      required: true
    },
    allowedRefuseValue: {
      default: function() {
        return [1, 2, 3];
      }
    }
  },
  components: {
    'dropdown-select': DropdownSelect,
    'popover-field-select': PopoverFieldSelect,
    'user-boundary-comp': user_boundary_select_comp,
    'operation-btn-switch': operation_btn_switch,
    'operation-btn-checkbox': operation_btn_checkbox,
    'time-span': TimeSpan,
    'business-time-comp': business_time_comp,
    'tabs': Tabs,
    'tab': TabItem
  },
  computed: {
    vertex: function() {
      return this.element;
    },
    userBoundaryCompOptions: function() {
      var options;
      options = [];
      if (!(this.vertex.isInitial || this.vertex.isFinal)) {
        options.push({
          name: 'dynamic-reviewer',
          previousVerticesUrl: this.vertex.getPreviousVerticesUrl(),
          title: '动态负责人',
          selectedVertexIds: this.vertex.user_boundary.reviewer_vertex_ids
        });
      }
      return options;
    },
    ccUserBoundaryCompOptions: function() {
      var options;
      options = [];
      if (!this.vertex.isInitial) {
        options.push({
          name: 'dynamic-reviewer',
          previousVerticesUrl: this.vertex.getPreviousVerticesUrl(),
          title: '动态抄送人',
          selectedVertexIds: this.vertex.cc_user_boundary.cc_vertex_ids
        });
      }
      return options;
    },
    selectedFields: function() {
      var result, selected_ids;
      result = [];
      selected_ids = this.vertex.field_ids;
      _.each(this.formatDataFunc(), function(group) {
        var _group;
        _group = _.clone(group);
        _group.options = _.filter(group.options, function(option) {
          return _.contains(selected_ids, option.id);
        });
        if (_group.options.length) {
          return result.push(_group);
        }
      });
      return result;
    }
  },
  data: function() {
    return {
      duration: '',
      business_time_enabled: false,
      business_time: {},
      allowedApproveValue: [1, 2],
      initialSettingsAssignManual: false
    };
  },
  created: function() {
    return this._resetDurationThreshold();
  },
  mounted: function() {
    if (!this.vertex.isFinal) {
      this.$watch('vertex.operations', _.debounce(function() {
        return this.updateVertex();
      }, 1000), {
        deep: true
      });
      return this.$watch('vertex.settings', _.debounce(function() {
        return this.updateVertex();
      }, 1000), {
        deep: true
      });
    }
  },
  watch: {
    'vertex.field_ids': _.debounce(function() {
      return this.updateVertex();
    }, 1000),
    'vertex.name': _.debounce(function() {
      return this.updateVertex();
    }, 1000),
    'vertex.alias_name': _.debounce(function() {
      return this.updateVertex();
    }, 1000),
    'duration': function() {
      return this.$nextTick(function() {
        return this.$refs.timespanRef.reset();
      });
    },
    'vertex.settings.assign_manually': {
      handler: function(value) {
        return this.initialSettingsAssignManual = value ? true : false;
      },
      immediate: true
    },
    'vertex': function() {
      return this._reset();
    }
  },
  methods: {
    formatDataFunc: function(graphs) {
      graphs = graphs || this.vertex.graph.getAncestors().concat(this.vertex.graph);
      return _.map(graphs, function(graph) {
        return {
          name: graph.name || graph.title,
          id: graph.id,
          options: _.map(graph.getOwnFields(), function(field) {
            return {
              name: field.title,
              id: field.id,
              own_option: field
            };
          })
        };
      });
    },
    updateDurationThresholdFunc: function(value) {
      this.duration = value;
      return this.vertex.settings.duration_threshold.value = this.duration;
    },
    toggleBusinessTimeEnabled: function() {
      this.business_time_enabled = !this.business_time_enabled;
      return this.updateBusinessTimeFunc(this.business_time);
    },
    updateBusinessTimeFunc: function(value) {
      this.vertex.settings.duration_threshold.enable_business_time = this.business_time_enabled;
      this.business_time = value;
      return this.vertex.settings.duration_threshold.business_time = this.business_time;
    },
    refuseValueChangeFunc: function(option) {
      return this.vertex.settings.refuse_mode = option;
    },
    setAssignManually: function(event) {
      return this.vertex.settings.assign_manually = event.target.checked ? 1 : 0;
    },
    approveValueChangeFunc: function(option) {
      return this.vertex.settings.assign_manually = option;
    },
    updateVertexFields: function(result) {
      return this.vertex.field_ids = result.option_ids;
    },
    userBoundaryChangeFunc: function(ub, options) {
      this.vertex.user_boundary.update(ub);
      if (options.vertices_boundary) {
        this.vertex.user_boundary.reviewer_vertex_ids = _.pluck(options.vertices_boundary, 'id');
        this.vertex.user_boundary.reviewerVertices = options.vertices_boundary;
      }
      return this.updateVertex();
    },
    ccUserBoundaryChangeFunc: function(ub, options) {
      this.vertex.cc_user_boundary.update(ub);
      if (options.vertices_boundary) {
        this.vertex.cc_user_boundary.cc_vertex_ids = _.pluck(options.vertices_boundary, 'id');
        this.vertex.cc_user_boundary.ccVertices = options.vertices_boundary;
      }
      return this.updateVertex();
    },
    updateVertex: function() {
      return this.vertex.update();
    },
    _reset: function() {
      this._resetDurationThreshold();
      return this.$nextTick(function() {
        var ref, ref1;
        if ((ref = this.$refs.timespanRef) != null) {
          ref.reset();
        }
        return (ref1 = this.$refs.businessTimeRef) != null ? ref1.reset() : void 0;
      });
    },
    _fieldIcon: function(option) {
      return option.own_option.getTypeIcon();
    },
    _resetDurationThreshold: function() {
      this.duration = this.element.settings.duration_threshold.value || '';
      this.business_time_enabled = this.element.settings.duration_threshold.enable_business_time;
      return this.business_time = this.element.settings.duration_threshold.business_time;
    }
  }
});
